<script>
  import { locale } from "svelte-i18n";
  import { currentLang } from "../stores.js";

  let lang = $locale;
  const handleSetLang = (selectedLang) => {
    lang = selectedLang;
    currentLang.set(lang);
    locale.set(lang);
  };
</script>

<div class="lang-switch">
  <div
    class={`button ${lang === "de" ? "selected" : ""}`}
    on:click={() => handleSetLang("de")}
  >
    DE
  </div>
  <div class="dot-decoration">•</div>
  <div
    class={`button ${lang === "fr" ? "selected" : ""}`}
    on:click={() => handleSetLang("fr")}
  >
    FR
  </div>
</div>

<style>
  .lang-switch {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 24px 0;
  }

  .dot-decoration {
    font-size: 12px;
    color: #999;
  }

  .button {
    padding: 0 4px;
    margin: 0;
    text-transform: uppercase;
    font-size: 18px;
    color: #999;
    border: none;
    outline: none;
    background-color: inherit;
    cursor: pointer;
  }

  .button.selected {
    color: black;
  }
</style>
